import { useCallback, useState } from 'react';
import { clientBillingApi } from '@cp/entities/client/current/billing';
// FIXME: upper level import
import { INFO_MODAL_NAME } from 'src/app/shared/components/modals/info/const';
import { useModal } from 'src/shared/modalProvider';
import { useApiServerErrorHandler } from 'src/shared/apiServer';
import { useTrackEvent } from 'src/shared/tracking';
import { BillingEvents } from '../events';

export const useStopBillingSubscription = () => {
  const { openModal } = useModal();
  const [isLoading, setLoading] = useState(false);
  const handleApiServerError = useApiServerErrorHandler();
  const [stopSubscription] = clientBillingApi.endpoints.stopBillingSubscription.useMutation();
  const track = useTrackEvent();

  return [
    useCallback(async () => {
      try {
        setLoading(true);
        const isConfirmed = await new Promise((resolve, reject) => {
          track(BillingEvents.SubscriptionCancel());
          openModal(INFO_MODAL_NAME, {
            title: 'Отмена продления',
            message: 'Текущая подписка остается действующей. Мы отключим только автоматический платеж.',
            onModalDestroy: reject,
            actions: [
              {
                title: 'Отменить продление',
                variant: 'primary',
                callback: () => resolve(true),
              },
            ],
          });
        });

        if (!isConfirmed) {
          return;
        }

        const response = await stopSubscription();

        if ('error' in response) {
          handleApiServerError(response.error);
        }
      } finally {
        setLoading(false);
      }
    }, [handleApiServerError, openModal, stopSubscription, track]),
    { isLoading },
  ] as const;
};
